export default __webpack_public_path__ + "static/media/image-ph-health-alarm-w@2x.88310e9b.webp";